import React from "react";
import ContactService from "../../services/ContactService";
import NewsService from "../../services/NewsService";
import InvestmentService from "../../services/InvestmentService";
import ContactDraftService from "../../services/ContactDraftService";
import HistoricalAumService from "../../services/HistoricalAumService";
import RealEstateInvestmentService from "../../services/RealEstateInvestmentService";

function useInvestorDeleter(session, snackbar, drafts=false) {

    const contacts = async (contact) => {
        if (drafts) {
            await deleteEntity(ContactDraftService, contact, "Contact Draft");
        } else {
            await deleteEntity(ContactService, contact, "Contact");
        }
    }

    const investments = async (investment) => {
        await deleteEntity(InvestmentService, investment, "Investment")
    }

    const realEstateInvestments = async (real_estate_investment) => {
        await deleteEntity(RealEstateInvestmentService, real_estate_investment, "Real Estate Investment");
    }

    const news = async (pieceOfNews) => {
        await deleteEntity(NewsService, pieceOfNews, "News");
    }

    const historicalAums = async (historicalAum) => {
        await deleteEntity(HistoricalAumService, historicalAum, "Historical AUM");
    }

    const deleteEntity = async (service, entity, entityName) => {
        try {
            const deleteResponse = await service.delete(entity.id, session);

            if (deleteResponse.data.status === 'success') {
                snackbar.show(`${entityName} deleted successfully`, "success");
            } else {
                snackbar.show(deleteResponse.data.message, "warning");
            }
        } catch (e) {
            console.error(e);
            snackbar.show(`Error when deleting ${entityName}`, "warning");
        }
    }

    return {
        contacts,
        investments,
        realEstateInvestments,
        news,
        historicalAums,
    };
}

export default useInvestorDeleter;